import { FC } from 'react';
import classnames from 'classnames';
import { useFragment, graphql } from 'react-relay';
import { getSrcsetString } from 'dibs-image-utils/exports/srcSet';

// components
import { PdpRespSharedStoryTellingText } from './PdpRespSharedStoryTellingText';
import { PdpSharedStoryTellingMainMedia } from '../../shared/PdpSharedStoryTelling/PdpSharedStoryTellingMainMedia';
import { PdpSharedStoryTellingShopAllLink } from '../../shared/PdpSharedStoryTelling/PdpSharedStoryTellingShopAllLink';

// styles
import styles from './PdpRespSharedStoryTellingTab.scss';

// types
import { PdpRespSharedStoryTellingTab_storyTellingTab$key as StoryTellingTab } from './__generated__/PdpRespSharedStoryTellingTab_storyTellingTab.graphql';

const storyTellingTabQuery = graphql`
    fragment PdpRespSharedStoryTellingTab_storyTellingTab on StoryTellingTab {
        mainImage
        mainVideo
        smallImage
        ...PdpRespSharedStoryTellingText_storyTellingTab
        ...PdpSharedStoryTellingMainMedia_refactor_storyTellingTab
        ...PdpSharedStoryTellingShopAllLink_refactor_storyTellingTab
    }
`;

export const PdpRespSharedStoryTellingTab: FC<{
    dataTn?: string;
    showHeader?: boolean;
    wrapperClass?: string;
    clearBackground: boolean;
    showExpandingArea?: boolean;
    storyTellingTab: StoryTellingTab;
}> = ({
    dataTn,
    wrapperClass,
    clearBackground,
    showExpandingArea,
    showHeader = true,
    storyTellingTab: storyTellingTabRef,
}) => {
    const storyTellingTab = useFragment(storyTellingTabQuery, storyTellingTabRef);
    const { smallImage, mainImage, mainVideo } = storyTellingTab;

    return (
        <div
            className={classnames(styles.tabContainer, wrapperClass, {
                [styles.clearBackground]: !!clearBackground,
            })}
            data-tn={dataTn}
        >
            <div className={styles.innerTabContainer}>
                {smallImage && (
                    <div className={`${styles.imageColumn} ${styles.smallImageCol}`}>
                        <div className={styles.smallImageWrapper}>
                            <img
                                alt=""
                                sizes="20vw"
                                src={smallImage}
                                className={styles.smallImage}
                                srcSet={getSrcsetString(smallImage)}
                            />
                        </div>
                        <PdpSharedStoryTellingShopAllLink storyTellingTab={storyTellingTab} />
                    </div>
                )}
                <div className={styles.textCol}>
                    <PdpRespSharedStoryTellingText
                        showHeader={showHeader}
                        storyTellingTab={storyTellingTab}
                        showExpandingArea={showExpandingArea}
                    />
                </div>
                {(mainImage || mainVideo) && (
                    <div
                        className={classnames(styles.imageColumn, styles.mainImageCol, {
                            [styles.largeImageAndText]: mainImage || mainVideo,
                        })}
                    >
                        <PdpSharedStoryTellingMainMedia storyTellingTab={storyTellingTab} />
                    </div>
                )}
            </div>
        </div>
    );
};
